import { render, staticRenderFns } from "./sel_staff.vue?vue&type=template&id=625904f8"
import script from "./sel_staff.vue?vue&type=script&lang=js"
export * from "./sel_staff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports